import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'hidePhone' })
export class HidePhonePipe implements PipeTransform {

  transform(value: string): any {
    if (value === null || value === undefined) {
      return '';
    }
    return value.replace(/\d(?=\d{4})/g, "*");
  }
}
